import { AxiosRequestConfig } from "axios";
import { RefabricProURL } from "../index";
import { ApiResponse } from "../HttpClient";
import { IAskChatbotRequest, IAskChatbotResponse, ICancelChatbotRequest, IChatbotReviewEligibilityResponse, ICreateChatbotReviewCaseRequest, ICreateChatbotReviewCaseResponse } from "./chatbot.type";

export default {
  async askQuestion(data: IAskChatbotRequest, options?: AxiosRequestConfig): Promise<ApiResponse<IAskChatbotResponse>> {
    return await RefabricProURL.post("chatbot/ask", data, options);
  },
  async cancelStream(data: ICancelChatbotRequest): Promise<ApiResponse<unknown>> {
    return await RefabricProURL.post("chatbot/cancel", data, {});
  },
  /** May this user capture a turn for human review? Server-authoritative allowlist (REF-6217 P1-0). */
  async getReviewEligibility(): Promise<ApiResponse<IChatbotReviewEligibilityResponse>> {
    return await RefabricProURL.get("chatbot/review-eligibility");
  },
  /** Snapshot one assistant turn as an immutable review case; returns the Backoffice link. */
  async createReviewCase(data: ICreateChatbotReviewCaseRequest): Promise<ApiResponse<ICreateChatbotReviewCaseResponse>> {
    return await RefabricProURL.post("chatbot/review-cases", data, {});
  },
};
